// React
import { useCallback } from 'react'

export const useNavigation = () => {
  const backToStore = useCallback(() => {
    const previewing = window.location.pathname.includes('/preview')
    const backUrl = window.booqableOptions?.cart.backToStoreUrl

    if (previewing || !backUrl) {
      return window.history.back()
    }

    return window.location.replace(backUrl)
  }, [])

  return { backToStore }
}
